import { useDispatch } from 'react-redux';

import { Snackbar } from '@hh.ru/magritte-ui';
import { MinusCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { makeSetStoreField } from '@hh.ru/redux-create-reducer';

import { useSelector } from '../../modules/useSelector';
import translation from '../translation';
import { TranslatedComponent } from '../translation/useTranslations';

const TrlKeys = {
    defaultError: 'lux.error',
    networkError: 'lux.error.network',
};

const SPAErrorAction = makeSetStoreField('SPAError');

const SPAError: TranslatedComponent = ({ trls }) => {
    const SPAError = useSelector(({ SPAError }) => SPAError);
    const dispatch = useDispatch();

    if (!SPAError) {
        return null;
    }

    const resetSPAError = () => dispatch(SPAErrorAction(null));

    return (
        <Snackbar addon={<MinusCircleFilledSize24 initial="negative" />} onClose={resetSPAError}>
            {trls[SPAError === 'default' ? TrlKeys.defaultError : TrlKeys.networkError]}
        </Snackbar>
    );
};

export default translation(SPAError);
